import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Check, Clock, Copy, WarningCircle} from '../../../icons';
import {NS} from './subscriptionPageModel';

const PILL_ICONS = {ok: Check, warn: Clock, bad: WarningCircle};

/**
 * La pastilla de estado. El color nunca va solo (heurísticas §2): siempre lleva el texto y, en los tres
 * estados con color, un ícono de forma distinta.
 */
export function Pill({tone = 'neutral', children}) {
    const Icon = PILL_ICONS[tone];
    return (
        <span className={`sp-pill -${tone}`}>
            {Icon && <Icon size={13} weight="bold" aria-hidden="true"/>}
            {children}
        </span>
    );
}

/** Un botón con cara de link, para las acciones secundarias de una fila. */
export function LinkButton({onClick, children, className = '', ...rest}) {
    return (
        <button type="button" className={`sp-linkbtn ${className}`} onClick={onClick} {...rest}>
            {children}
        </button>
    );
}

/** «Copiar» → «Copiado» un momento. Si el portapapeles no está, no promete nada. */
export function CopyButton({value}) {
    const {t} = useTranslation();
    const [copied, setCopied] = useState(false);
    const canCopy = typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText;
    if (!canCopy) return null;
    const copy = () => {
        navigator.clipboard.writeText(value).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }).catch(() => {});
    };
    return (
        <button type="button" className="sp-copy" onClick={copy}>
            <Copy size={14} aria-hidden="true"/>
            <span aria-live="polite">{copied ? t(`${NS}.overdue.copied`) : t(`${NS}.overdue.copy`)}</span>
        </button>
    );
}

/** Los datos para transferir, renglón por renglón, cada uno con su «Copiar». */
export function BankTransferDetails({lines, titleId}) {
    const {t} = useTranslation();
    if (!lines || lines.length === 0) return null;
    return (
        <div className="sp-transfer">
            <h3 className="sp-transfer__title" id={titleId}>{t(`${NS}.overdue.transfer_title`)}</h3>
            <dl className="sp-transfer__list">
                {lines.map((line, index) => (
                    <div className="sp-transfer__row" key={`${line.label}-${index}`}>
                        {line.label && <dt>{line.label}</dt>}
                        <dd>
                            <span className="sp-transfer__value">{line.value}</span>
                            <CopyButton value={line.value}/>
                        </dd>
                    </div>
                ))}
            </dl>
        </div>
    );
}
